export default __webpack_public_path__ + "static/media/friend.17843859.svg";